/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AcademicUser,
    AcademicUserFromJSON,
    AcademicUserFromJSONTyped,
    AcademicUserToJSON,
} from './AcademicUser';
import {
    Department,
    DepartmentFromJSON,
    DepartmentFromJSONTyped,
    DepartmentToJSON,
} from './Department';
import {
    Domain,
    DomainFromJSON,
    DomainFromJSONTyped,
    DomainToJSON,
} from './Domain';
import {
    Laboratory,
    LaboratoryFromJSON,
    LaboratoryFromJSONTyped,
    LaboratoryToJSON,
} from './Laboratory';
import {
    StudyProgram,
    StudyProgramFromJSON,
    StudyProgramFromJSONTyped,
    StudyProgramToJSON,
} from './StudyProgram';
import {
    UniversityCenter,
    UniversityCenterFromJSON,
    UniversityCenterFromJSONTyped,
    UniversityCenterToJSON,
} from './UniversityCenter';

/**
 * 
 * @export
 * @interface Faculty
 */
export interface Faculty {
    /**
     * 
     * @type {string}
     * @memberof Faculty
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof Faculty
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Faculty
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Faculty
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Faculty
     */
    universityCenterId?: string;
    /**
     * 
     * @type {number}
     * @memberof Faculty
     */
    orderNumber?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Faculty
     */
    isDoctoralSchool?: boolean;
    /**
     * 
     * @type {UniversityCenter}
     * @memberof Faculty
     */
    universityCenter?: UniversityCenter;
    /**
     * 
     * @type {Array<Domain>}
     * @memberof Faculty
     */
    domains?: Array<Domain> | null;
    /**
     * 
     * @type {Array<StudyProgram>}
     * @memberof Faculty
     */
    studyPrograms?: Array<StudyProgram> | null;
    /**
     * 
     * @type {Array<Laboratory>}
     * @memberof Faculty
     */
    laboratories?: Array<Laboratory> | null;
    /**
     * 
     * @type {Array<Department>}
     * @memberof Faculty
     */
    departments?: Array<Department> | null;
    /**
     * 
     * @type {Array<AcademicUser>}
     * @memberof Faculty
     */
    adminUsers?: Array<AcademicUser> | null;
    /**
     * 
     * @type {string}
     * @memberof Faculty
     */
    readonly abbreviation?: string | null;
}

export function FacultyFromJSON(json: any): Faculty {
    return FacultyFromJSONTyped(json, false);
}

export function FacultyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Faculty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'universityCenterId': !exists(json, 'universityCenterId') ? undefined : json['universityCenterId'],
        'orderNumber': !exists(json, 'orderNumber') ? undefined : json['orderNumber'],
        'isDoctoralSchool': !exists(json, 'isDoctoralSchool') ? undefined : json['isDoctoralSchool'],
        'universityCenter': !exists(json, 'universityCenter') ? undefined : UniversityCenterFromJSON(json['universityCenter']),
        'domains': !exists(json, 'domains') ? undefined : (json['domains'] === null ? null : (json['domains'] as Array<any>).map(DomainFromJSON)),
        'studyPrograms': !exists(json, 'studyPrograms') ? undefined : (json['studyPrograms'] === null ? null : (json['studyPrograms'] as Array<any>).map(StudyProgramFromJSON)),
        'laboratories': !exists(json, 'laboratories') ? undefined : (json['laboratories'] === null ? null : (json['laboratories'] as Array<any>).map(LaboratoryFromJSON)),
        'departments': !exists(json, 'departments') ? undefined : (json['departments'] === null ? null : (json['departments'] as Array<any>).map(DepartmentFromJSON)),
        'adminUsers': !exists(json, 'adminUsers') ? undefined : (json['adminUsers'] === null ? null : (json['adminUsers'] as Array<any>).map(AcademicUserFromJSON)),
        'abbreviation': !exists(json, 'abbreviation') ? undefined : json['abbreviation'],
    };
}

export function FacultyToJSON(value?: Faculty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'name': value.name,
        'universityCenterId': value.universityCenterId,
        'orderNumber': value.orderNumber,
        'isDoctoralSchool': value.isDoctoralSchool,
        'universityCenter': UniversityCenterToJSON(value.universityCenter),
        'domains': value.domains === undefined ? undefined : (value.domains === null ? null : (value.domains as Array<any>).map(DomainToJSON)),
        'studyPrograms': value.studyPrograms === undefined ? undefined : (value.studyPrograms === null ? null : (value.studyPrograms as Array<any>).map(StudyProgramToJSON)),
        'laboratories': value.laboratories === undefined ? undefined : (value.laboratories === null ? null : (value.laboratories as Array<any>).map(LaboratoryToJSON)),
        'departments': value.departments === undefined ? undefined : (value.departments === null ? null : (value.departments as Array<any>).map(DepartmentToJSON)),
        'adminUsers': value.adminUsers === undefined ? undefined : (value.adminUsers === null ? null : (value.adminUsers as Array<any>).map(AcademicUserToJSON)),
    };
}

